import { GET, POST, PUT, DELETE } from "../../api";

export const Country = async (id) => {
  return await GET(`/common/masters/all-country`);
};

export const State = async (id) => {
  return await GET(`/common/masters/all-state/${id}`);
};

export const City = async (id) => {
  return await GET(`/common/masters/all-city/${id}`);
};

export const Pincode = async (id) => {
  return await GET(`/common/masters/all-pincode/${id}`);
};

export const Modules = async () => {
  return await GET(`/common/masters/all-modules`);
};

export const ThingToDo = async () => {
  return await GET(`/common/masters/all-things-to-do`);
};

export const ExploreType = async () => {
  return await GET(`/common/masters/all-explore-type`);
};

export const AllGames = async () => {
  return await GET(`/common/masters/all-games`);
};

export const AllRoles = async () => {
  return await GET(`/common/masters/all-roles`);
};

export const AllWalletType = async () => {
  return await GET(`/common/masters/all-wallet-type`);
};

export const stores = async (date = null) => {
  return await GET(
    `/common/masters/drop-stores?date=${date ?? ""}`,
    {},
    process.env.REACT_APP_MATKA_BASE_URL,
  );
};

export const AllPermission = async () => {
  return await GET(`/common/masters/all-permission`);
};

export const allPaymentMethod = async (id) => {
  return await GET(`/common/masters/all-payment-method`);
};
